var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.595,
    height: 30.484,
    viewBox: "0 0 21.595 30.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-location-on",
    "data-name": "Icon material-location-on",
    d: "M17.3,3a9.79,9.79,0,0,0-9.8,9.8c0,7.348,9.8,18.195,9.8,18.195s9.8-10.847,9.8-18.195A9.79,9.79,0,0,0,17.3,3Zm0,13.3a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,17.3,16.3Z",
    transform: "translate(-6.5 -2)",
    fill: "none",
    stroke: "#186aa5",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn);
export default __webpack_public_path__ + "static/media/location-on.81b5c87007c43f0fa4fc0e341e696294.svg";
export { ForwardRef as ReactComponent };